import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectGalleryService } from 'src/app/services/project-gallery.service';
import { ActivatedRoute } from '@angular/router';
import { AppGlobals } from 'src/app/app.globals';
import { SharedPipesModule } from "src/app/pipes/shared.pipes.module";
import * as mime from 'mime';

import { DxTileViewModule, DxGalleryModule, DxPopupModule, DxTreeListModule, DxDropDownButtonModule, DxFormModule, DxButtonModule, DxContextMenuModule, DxTextBoxModule } from 'devextreme-angular';
import { fail } from 'assert';
import { environment } from 'src/environments/environment';
import { DxTreeListComponent, DxTreeListTypes } from 'devextreme-angular/ui/tree-list';
import { text } from 'stream/consumers';
import { isContext } from 'vm';
import { files } from 'jszip';
import { ConsoleLogger } from '@microsoft/signalr/dist/esm/Utils';
import { AppConfig } from 'src/app/app.config';
import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivitySection } from 'src/app/constants/activity-log';

@Component({
    selector: 'app-project-documents',
    imports: [DxTextBoxModule, DxContextMenuModule, CommonModule, SharedPipesModule, DxTileViewModule, DxGalleryModule, DxPopupModule, DxTreeListModule, DxDropDownButtonModule, DxFormModule, DxButtonModule],
    templateUrl: './project-gallery.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./project-gallery.page.css']
})
export class ProjectGalleryPage implements OnInit, OnDestroy {

    @ViewChild("commentFileInput") commentFileInput;
    @ViewChild("fileContextMenu") fileContextMenu;

    projectId: number = null;

    galleryData: any = [];
    galleryFolderData: any = [];

    noDataText: string = $localize`:@@noImagesAvailable:No images available`;
    galleryVisible: boolean = false;

    imagePlaceholder: string = 'assets/images/elements/gallery-placeholder.png';
    folderTitle: string = ''
    fileUploadData: any = null;

    focusImagesVisible: boolean = false;
    focusImageIndex: number = 0;
    focusTitle: string = $localize`:@@projectImageGallery:Project Image Gallery`;
    rootFolder: string = "Shared%20Documents/WIProjectsv2/522_b_test_too/522_1_b_test_two/000_bilder";

    selectedFolder: any = null;
    foldersLoaded: boolean = false;
    isRename: boolean = false;
    newFolderName: string = '';
    imageQueueList: any = [];
    imageQueueId: number = 0;
    folderPath: string = '';
    renderCount: number = 0;
    rename: string = $localize`Rename Folder`;
    add: string = $localize`Add Folder`;
    folderOptions: any = [$localize`:@@newFolder:New Folder`];
    currentFolderPath: string = '';

    newFolderData: any = { ParentFolder: '', NewFolderName: '' };
    newFolderFormVisible: boolean = false;
    viewFile: boolean = false;
    fileSrc: string = '';

    preloadFolderPath: string = null; //'/sites/ITIntern/Shared Documents/WIProjectsv2/044_bad_bodenteich/044_1_bad_bodenteich/000_bilder/testA/New C';

    popupVisible: boolean = false;
    galleryIsActive: boolean = false;
    isRenameVisible: boolean = true;
    contextMenuItems: any[] = [
        { text: $localize`Create Folder`, icon: 'add', id: 'create' },
        { text: $localize`Rename Folder`, icon: 'edit', id: 'rename' },
        { text: $localize`Delete`, icon: 'trash', id: 'delete' }
    ];
    contextMenuTarget: any = null;
    renameFormVisible: boolean = false;
    renameData: any = { ItemPath: '', NewName: '' };
    isCreatingNewFolder: boolean = false;
    confirmDeletePopupVisible: boolean = false;
    deleteTargetName: string = '';

    constructor(private appGlobals: AppGlobals, private service: ProjectGalleryService, private activatedRoute: ActivatedRoute, private activityLog: ActivityLogService) {
        this.onReorder = this.onReorder.bind(this);
    }

    ngOnInit(): void {
        this.appGlobals.SetGlobalMenuIndex(2);
        console.clear();

        this.galleryIsActive = true; // images will only download while component is active
        this.galleryVisible = false;
        this.projectId = parseInt(this.activatedRoute.snapshot.params.id);
        this.activityLog.logView({ Section: ActivitySection.PROJECT_GALLERY, ProjectId: this.projectId });
        this.getGallery();
    }

    ngOnDestroy(): void {
        this.galleryIsActive = false; // stop images from downloading if component is no longer active
    }

    getGallery(): void {

        this.galleryVisible = false;
        this.galleryData = [];
        this.resetImageQueueList();

        this.service.getProjectImageGallery({ ProjectId: this.projectId }).then((result) => {
            if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
            else {
                this.galleryFolderData = [result.galleryFolders];
                if (this.selectedFolder == null) {
                    this.preloadFolderPath = this.galleryFolderData[0].serverRelativeUrl;
                }
                this.foldersLoaded = true;
                this.initImageGrid();
                console.log(this.galleryFolderData);

                //this.folderTreeList.instance.selectedRowKeys = [this.galleryFolderData[0].key];
            }
        },
            (error: any) => {
                AppGlobals.ShowErrorMessage(error);
            });

    }

    onContextMenu(event: MouseEvent, item: any): void {
        event.preventDefault();


        this.contextMenuTarget = item;

        // Dynamically update the visibility
        const renameItem = this.contextMenuItems.find(i => i.id === 'rename');
        const createItem = this.contextMenuItems.find(i => i.id === 'create');
        const deleteItem = this.contextMenuItems.find(i => i.id === 'delete');
        if (renameItem) {
            this.isRename = true;
            renameItem.visible = item.isDirectory && !item.serverRelativeUrl.endsWith('/000_bilder');
        }
        if (createItem) {
            this.isRename = false;
            createItem.visible = item.isDirectory && item.serverRelativeUrl;
        }

        if (deleteItem) {
            deleteItem.visible = !(item.isDirectory && item.serverRelativeUrl.endsWith('/000_bilder'));
        }

        this.fileContextMenu.instance.option('items', this.contextMenuItems);
        this.fileContextMenu.instance.option('target', event.target);
        this.fileContextMenu.instance.show();
    }


    onContextMenuItemClick(e: any): void {
        const itemId = e.itemData.id;

        if (itemId === 'create') {
            this.isCreatingNewFolder = true;
            this.isRename = false;
            this.folderTitle = $localize`Add New Folder`
            this.openRenameForm();
        } else if (itemId === 'rename') {
            this.isCreatingNewFolder = false;
            this.isRename = true;
            this.folderTitle = $localize`Rename Folder`
            this.openRenameForm();
        } else if (itemId === 'delete') {
            this.deleteItem();
        }
    }

    submitFolderAction(): void {
        if (this.isCreatingNewFolder) {
            this.submitNew();
        } else {
            this.submitRename();
        }
    }



    openRenameForm(): void {
        this.popupVisible = true;
        if (!this.contextMenuTarget) return;

        if (!this.isCreatingNewFolder) {

            const pathParts = this.contextMenuTarget.serverRelativeUrl.split("/");
            pathParts.pop();
            this.folderPath = pathParts.join("/");
        } else {
            this.folderPath = this.contextMenuTarget.serverRelativeUrl;
        }

        this.renameData = {
            ParentFolder: this.folderPath,
            OldFolderName: this.contextMenuTarget.name,
            NewFolderName: this.newFolderName,
            IsDirectory: this.contextMenuTarget.isDirectory
        };
        this.renameFormVisible = true;
    }

    submitNew(): void {
        if (this.newFolderName === '') return;
        this.renameData.NewFolderName = this.newFolderName;
        this.renameData.ProjectId = this.projectId;

        this.service.addProjectGalleryFolder(this.renameData).then((result) => {
            if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
            else {
                this.refreshFolders();
                // this.newFolderFormVisible = false;
                this.preloadFolderPath = this.selectedFolder.serverRelativeUrl;
                // this.popupVisible = false
                this.newFolderName = null;
            }
        },
            (error: any) => {
                AppGlobals.ShowErrorMessage(error);
            });
    }

    submitRename(): void {
        if (this.newFolderName === '') return;

        this.renameData.NewFolderName = this.newFolderName;
        this.renameData.ProjectId = this.projectId;

        this.service.editProjectGalleryFolder(this.renameData).then((result) => {
            if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
            else {
                this.refreshFolders();
                // this.renameFormVisible = false;
                // this.popupVisible = false
                this.newFolderName = null;
            }
        },
            (error: any) => {
                AppGlobals.ShowErrorMessage(error);
            });
    }

    onReorder(e: any): void {
        console.clear();
        const visibleRows = e.fromComponent.getVisibleRows();
        const draggedItem = e.itemData;
        const targetItem = e.toIndex !== undefined ? visibleRows[e.toIndex]?.data : null;

        const dropInsideItem = e.dropInsideItem;

        if (dropInsideItem && targetItem) {

            const currentPath = draggedItem.serverRelativeUrl.split("/");;
            const destinationPath = targetItem.serverRelativeUrl;

            currentPath.pop();
            this.currentFolderPath = currentPath.join("/");
            const payload = {
                ProjectId: this.projectId,
                currentPath: this.currentFolderPath,
                destinationPath,
                currentFolderName: draggedItem.name
            };
            const FilePayload = {
                ProjectId: this.projectId,
                currentPath: draggedItem.serverRelativeUrl,
                destinationPath,
                currentFileName: draggedItem.name
            }
            if (draggedItem.isDirectory) {
                this.service.moveProjectFolderGallery(payload).then(
                    (result) => {
                        if (result.hasError === true) {
                    AppGlobals.ShowErrorMessage($localize`:@@sharePointStructureError:The current SharePoint folder structure does not support items of this length. Please shorten the name or adjust the structure.`);
                        } else {
                            this.renameFormVisible = false;
                            this.popupVisible = false;
                            this.newFolderName = null;

                            this.updateFolderHierarchy(draggedItem, targetItem);
                            this.refreshFolders();
                        }
                    },
                    (error: any) => {
                        AppGlobals.ShowErrorMessage(error);
                    }
                );
            } else {
                this.service.moveProjectFileGallery(FilePayload).then(
                    (result) => {
                        if (result.hasError === true) {
                            AppGlobals.ShowErrorMessage(result.feedback);
                        } else {
                            this.renameFormVisible = false;
                            this.popupVisible = false;
                            this.newFolderName = null;

                            this.updateFolderHierarchy(draggedItem, targetItem);
                            this.refreshFolders();
                        }
                    },
                    (error: any) => {
                        AppGlobals.ShowErrorMessage(error);
                    }
                );
            }

        } else {
            console.log('Reordering at same level');
        }
    }

    onDragChange(e: any): void {
        const draggedData = e.itemData;
        const targetNode = e.toComponent.getNodeByKey(e.toIndex);
    }

    private updateFolderHierarchy(draggedItem: any, targetItem: any): void {
        const updateData = (items: any[]) => {
            for (let i = 0; i < items.length; i++) {
                if (items[i].key === draggedItem.key) {
                    items[i].parentId = targetItem.key;
                    return true;
                }

                if (items[i].items && items[i].items.length > 0) {
                    if (updateData(items[i].items)) {
                        return true;
                    }
                }
            }
            return false;
        };

        const updatedData = [...this.galleryFolderData];
        updateData(updatedData);

        this.galleryFolderData = updatedData;
    }



    deleteItem(): void {
        if (!this.contextMenuTarget) return;

        this.deleteTargetName = this.contextMenuTarget.name;
        this.confirmDeletePopupVisible = true;
    }


    confirmDelete(): void {
        if (!this.contextMenuTarget) return;

        const pathParts = this.contextMenuTarget.serverRelativeUrl.split("/");
        pathParts.pop();
        const folderPath = pathParts.join("/");
        const currentFolder = this.selectedFolder;

        // Check if we're deleting the currently selected folder
        const isDeletingSelectedFolder = this.contextMenuTarget.isDirectory &&
            currentFolder &&
            this.contextMenuTarget.key === currentFolder.key;

        // Check if we're deleting a parent folder of the currently selected folder
        const isDeletingParentFolder = this.contextMenuTarget.isDirectory &&
            currentFolder &&
            currentFolder.serverRelativeUrl.startsWith(this.contextMenuTarget.serverRelativeUrl);

        const deleteFolderData = {
            ProjectId: this.projectId,
            FolderPath: folderPath,
            FolderName: this.contextMenuTarget.name,
            IsDirectory: this.contextMenuTarget.isDirectory
        };

        const deleteFileData = {
            ProjectId: this.projectId,
            ParentFolder: this.contextMenuTarget.serverRelativeUrl,
            FileName: this.contextMenuTarget.name
        };

        const promise = this.contextMenuTarget.isDirectory
            ? this.service.deleteFolderProjectGallery(deleteFolderData)
            : this.service.deleteFileProjectGallery(deleteFileData);

        promise.then(result => {
            if (result.hasError) {
                AppGlobals.ShowErrorMessage(result.feedback);
            } else {
                // Handle navigation after successful deletion
                if (isDeletingSelectedFolder || isDeletingParentFolder) {
                    // Navigate back to root folder
                    this.navigateToRootFolder();
                } else {
                    // Keep current folder if it wasn't affected by the deletion
                    if (currentFolder) {
                        this.preloadFolderPath = currentFolder.serverRelativeUrl;
                    }
                }

                this.refreshFolders();

                const itemType = this.contextMenuTarget.isDirectory ? 'Folder' : 'File';
            }
            this.confirmDeletePopupVisible = false;
        }).catch(error => {
            AppGlobals.ShowErrorMessage(error);
            this.confirmDeletePopupVisible = false;
        });
    }

    // Helper method to navigate to root folder
    private navigateToRootFolder(): void {
        // Clear current selection
        this.selectedFolder = null;
        this.preloadFolderPath = null;

        // Clear gallery data
        this.galleryData = [];
        this.galleryVisible = false;

        // Reset to root folder - adjust this based on your root folder structure
        // Option 1: If you have a specific root folder object
        if (this.rootFolder) {
            this.selectedFolder = this.rootFolder;
            this.preloadFolderPath = this.rootFolder;
        }
        // Option 2: If root is represented by null/empty selection
        else {
            // Find and select the root folder from galleryFolderData
            const rootFolder = this.findRootFolder();
            if (rootFolder) {
                this.selectedFolder = rootFolder;
                this.preloadFolderPath = rootFolder.serverRelativeUrl;
            }
        }

        // Trigger folder selection to load root folder content
        if (this.selectedFolder) {
            this.loadFolderContent(this.selectedFolder);
        }
    }

    // Helper method to find root folder
    private findRootFolder(): any {
        // Option 1: Root folder has no parent
        const rootFolder = this.galleryFolderData?.find(folder =>
            !folder.parentId || folder.parentId === null || folder.parentId === ''
        );

        if (rootFolder) {
            return rootFolder;
        }

        // Option 2: Find the topmost folder in hierarchy
        const topLevelFolders = this.galleryFolderData?.filter(folder =>
            folder.isDirectory && (!folder.parentId || folder.parentId === null)
        );

        return topLevelFolders?.[0] || null;
    }

    // Optional: Helper method to check if a folder is ancestor of another
    private isAncestorFolder(ancestorPath: string, descendantPath: string): boolean {
        return descendantPath.startsWith(ancestorPath + '/') || descendantPath === ancestorPath;
    }

    // Optional: Enhanced method to load folder content
    private loadFolderContent(folder: any): void {
        // Clear current gallery
        this.galleryData = [];
        this.galleryVisible = false;

        // Load the folder's content - adjust based on your existing method
        // This might be something like:
        // this.loadGalleryForFolder(folder);
        // or trigger the existing folder click handler:
        // this.handleFolderRowClick({ data: folder });

        console.log('Loading content for folder:', folder.name);
    }



    initImageGrid(): void {

        this.galleryData.forEach((item: any) => {

            let heightRatio = 2;
            let widthRation = 2;

            if (this.galleryData.length > 3) {
                let ratPerc = Math.floor(Math.random() * 100);
                heightRatio = 1;
                widthRation = 1;

                if (ratPerc > 50) {
                    heightRatio = 1;
                    widthRation = 2;
                }

                if (ratPerc > 75) {
                    heightRatio = 2;
                    widthRation = 2;
                }

                if (ratPerc > 90) {
                    heightRatio = 3;
                    widthRation = 2;
                }
            }

            item.imageData = this.imagePlaceholder;
            item.heightRatio = heightRatio;
            item.widthRatio = widthRation;
            item.imageLoaded = false;

        });

        this.galleryVisible = true;
    }

    handleImageClick(e: any): void {
        this.focusImageIndex = e.itemIndex;
        this.focusImagesVisible = true;
    }


    resetImageQueueList(): void {
        this.imageQueueId++;
        this.imageQueueList = [];
    }

    async queueImageDownload(e: any) {

        if (this.galleryIsActive != true) return;
        let currentId = this.imageQueueId;

        this.imageQueueList.push(e);

        if (this.imageQueueList.length != this.galleryData.length) return;
        for (let i = 0; i < this.imageQueueList.length; i++) {
            if (this.galleryIsActive != true) return;

            if (this.galleryIsActive != true) return;
            if (this.imageQueueId != currentId) return;
            if (i > this.imageQueueList.length) return;
            if (this.imageQueueList[i] == null) return;

            await this.handleItemRendered(this.imageQueueList[i]);
        }
    }

    async handleItemRendered(e: any) {

        if (e.itemIndex >= this.galleryData.length) return;

        if (this.galleryIsActive === false) return;

        if (this.galleryData[e.itemIndex].imageLoaded === false) {

            return await this.service.getProjectGalleryImage(this.galleryData[e.itemIndex]).then((result) => {
                if (result.hasError === true) {
                    if (e.itemElement != null) {
                        if (e.itemElement.children != null && e.itemElement.children.length > 0) e.itemElement.children[0].children[0].className = 'gallery-image gallery-image-error';
                    }
                }
                else {

                    if (e.itemElement.children != null && e.itemElement.children.length > 0) {
                        this.galleryData[e.itemIndex].imageLoaded = true;
                        this.galleryData[e.itemIndex].imageData = result.imageData;
                        e.itemElement.children[0].children[0].style.backgroundImage = `url("${result.imageData}")`;
                        e.itemElement.children[0].children[0].className = 'gallery-image';
                    }
                }
            },
                (error: any) => {
                    console.error(error);
                    if (e.itemElement.children != null && e.itemElement.children.length > 0) e.itemElement.children[0].children[0].className = 'gallery-image gallery-image-error';
                });
        }
    }


    onDrop(event: any) {

        event.preventDefault();
        this.setFiles(event.dataTransfer.files);
        event.component.refresh;
    }


    onDragOver(event: any) {
        event.preventDefault();
        event.component.refresh;
    }



    triggerFileInput() {
        this.commentFileInput.nativeElement.click();
    }
    private draggedImage: any = null;
    private draggedImageIndex: number = -1;

    holdFileName: string = '';
    holdFilePath: string = '';
    onImageDragStart(event: DragEvent, imageItem: any, index: number): void {
        this.draggedImage = imageItem;
        this.draggedImageIndex = index;
        this.holdFileName = imageItem.FileName;
        this.holdFilePath = imageItem.FilePath;
        event.dataTransfer?.setData('text/plain', JSON.stringify({
            imageId: imageItem.id || index,
            imageIndex: index,
            imageData: imageItem
        }));

        const target = event.target as HTMLElement;
        target.classList.add('dragging');

        if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
        }
    }

    onImageDragEnd(event: DragEvent): void {
        const target = event.target as HTMLElement;
        target.classList.remove('dragging');
        this.clearAllDragOverStates();

        this.draggedImage = null;
        this.draggedImageIndex = -1;
    }

    onFolderDragEnter(event: DragEvent, folderData: any): void {
        event.preventDefault();
        event.stopPropagation();

        // Clear all other drag states first
        this.clearAllDragOverStates();

        const target = event.currentTarget as HTMLElement;
        target.classList.add('drag-over');
    }

    onFolderDragOver(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();

        // Set drop effect
        if (event.dataTransfer) {
            event.dataTransfer.dropEffect = 'move';
        }
    }
    onFolderDragLeave(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();

        const target = event.currentTarget as HTMLElement;
        const relatedTarget = event.relatedTarget as HTMLElement;

        // Only remove feedback if we're actually leaving the folder row
        // and not moving to a child element
        if (!target.contains(relatedTarget)) {
            target.classList.remove('drag-over', 'drag-valid', 'drag-invalid');
        }
    }

    private clearAllDragOverStates(): void {
        const allFolderRows = document.querySelectorAll('.gallery-folder-row');
        allFolderRows.forEach(row => {
            row.classList.remove('drag-over', 'drag-valid', 'drag-invalid');
        });
    }


    onImageDropToFolder(event: DragEvent, folderData: any): void {
        event.preventDefault();
        event.stopPropagation();
        this.clearAllDragOverStates();

        const target = event.currentTarget as HTMLElement;

        target.classList.remove('drag-over', 'drag-valid', 'drag-invalid');

        try {
            const dragData = event.dataTransfer?.getData('text/plain');
            if (!dragData) {
                console.error('No drag data found');
                return;
            }

            const imageInfo = JSON.parse(dragData);

            if (!folderData || !folderData.isDirectory) {
                console.error('Invalid folder data');
                this.showErrorMessage('Cannot drop image: Invalid folder');
                return;
            }

            if (!imageInfo || imageInfo.imageIndex === undefined) {
                console.error('Invalid image data');
                this.showErrorMessage('Cannot drop image: Invalid image data');
                return;
            }

            if (this.selectedFolder && this.selectedFolder.key === folderData.key) {
                return;
            }

            this.moveImageToFolder(imageInfo, folderData);

        } catch (error) {
            this.showErrorMessage('Error moving image to folder');
        }
    }

    private moveImageToFolder(imageInfo: any, targetFolder: any): void {
        const draggedItem = this.galleryData[imageInfo.imageIndex];

        if (!draggedItem) {
            this.showErrorMessage('Failed to move image: Item not found');
            return;
        }

        const destinationPath = this.buildDestinationPath(targetFolder);

        const FilePayload = {
            ProjectId: this.projectId,
            currentPath: this.holdFilePath,
            destinationPath: destinationPath,
            currentFileName: this.holdFileName
        };

        this.service.moveProjectFileGallery(FilePayload).then(
            (result) => {
                if (result.hasError === true) {
                    // AppGlobals.ShowErrorMessage(result.feedback);
                    AppGlobals.ShowErrorMessage($localize`:@@sharePointStructureError:The current SharePoint folder structure does not support items of this length. Please shorten the name or adjust the structure.`);
                } else {
                    this.renameFormVisible = false;
                    this.popupVisible = false;
                    this.newFolderName = null;

                    this.updateFolderHierarchy(draggedItem, destinationPath);
                    this.refreshFolders();
                }
            },
            (error: any) => {
                AppGlobals.ShowErrorMessage(error);
            }
        );
    }

    private buildDestinationPath(targetFolder: any): string {

        if (targetFolder.serverRelativeUrl) {
            return targetFolder.serverRelativeUrl;
        } else if (targetFolder.path) {
            return targetFolder.path;
        } else {
            return this.constructFolderPath(targetFolder);
        }
    }

    private constructFolderPath(folder: any): string {

        return folder.key || folder.name || '';
    }

    private showSuccessMessage(message: string): void {
    }

    private showErrorMessage(message: string): void {
        console.error('Error:', message);
    }



    async setFiles(files: any) {
        if (files == null) return;
        if (files.length == 0) return;

        

        const currentFolder = this.selectedFolder;

        for (let i = 0; i < files.length; i++) {
            let f = files[i];
            if (f.name == null) continue;
            if (f.name.length < 5) continue;
            if (f.type.indexOf('image') == -1) continue;
            if (f.name.length > AppConfig.MaxFileNameLength) {
                AppGlobals.ShowErrorMessage($localize`:@@fileNameTooLongError:File name is too long. Maximum allowed length is ${AppConfig.MaxFileNameLength}:maxLength: characters.`);
                return;
            }
            await this.uploadFile(files[i]);
        }

        if (currentFolder) {
            this.preloadFolderPath = currentFolder.serverRelativeUrl;
        }

        this.refreshFolders();
    }

    refreshFolders(): void {
        this.popupVisible = false;
        this.renameFormVisible = false;

        const currentFolderPath = this.selectedFolder ? this.selectedFolder.serverRelativeUrl : null;

        this.service.getProjectImageGallery({ ProjectId: this.projectId }).then((result) => {
            if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
            else {
                this.galleryFolderData = [result.galleryFolders];

                // After refreshing folders, if we have a selected folder path, find and reopen it
                if (this.preloadFolderPath) {
                    this.findAndSelectFolder(this.galleryFolderData[0], this.preloadFolderPath);
                }
            }
        },
            (error: any) => {
                AppGlobals.ShowErrorMessage(error);
            });
    }

    findAndSelectFolder(rootFolder: any, targetPath: string): void {
        const findFolder = (folder: any): boolean => {
            if (folder.serverRelativeUrl === targetPath) {
                this.selectedFolder = folder;
                this.openFolder(folder, null, {});
                return true;
            }

            if (folder.items && folder.items.length > 0) {
                for (const item of folder.items) {
                    if (findFolder(item)) {
                        return true;
                    }
                }
            }

            return false;
        };

        findFolder(rootFolder);
    }

    async uploadFile(fileData: any) {
        var formData = new FormData();
        formData.append("projectId", this.projectId.toString());
        formData.append("filename", fileData.name);
        formData.append("filebytes", fileData);
        formData.append("filebytesContentType", fileData.type);
        formData.append("uploadPath", this.selectedFolder.serverRelativeUrl);

        return this.service.addProjectImage(formData).then((result) => {
            if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
            else {
            }
        },
            (error: any) => {
                AppGlobals.ShowErrorMessage(error);
            });
    }



    handleFolderRowPrepared(e: any): void {
        if (e.data == null) return;
        if (e.data.isDirectory == false) e.rowElement.style.display = 'none';
        else {
            if (this.preloadFolderPath != null) {

                if (e.data.serverRelativeUrl == this.preloadFolderPath) {
                    this.preloadFolderPath = null;
                    this.selectedFolder = null;
                    this.handleFolderRowClick(e);
                }
            }
        }
    }


    handleFolderRowClick(e: any): void {
        // Only allow selection if it's a directory
        console.log(e.data);
        if (!e.data.isDirectory) {
            this.viewFile = true;
            this.getImage(e.data);
        }
        this.fileSrc = '';
        const component = e.component; // DevExtreme component reference

        // Clear previous selection
        component.clearSelection();

        // Select the new row by key
        component.selectRows([e.key], false); // false = do not preserve previous selection
        console.log(e);

        // Track selected folder
        this.selectedFolder = e.data;

        // Get node
        let nodes = null;
        if (e.row != null) nodes = e.row.node;
        else if (e.node != null) nodes = e.node;

        this.openFolder(e.data, nodes, e);
    }

    getImage(data: any): void {
        const payload = {
            ProjectId: this.projectId,
            FileName: data.name,
            FilePath: data.serverRelativeUrl,
            heightRatio: 1,
            imageData: data.imageData,
            widthRatio: 1
        }


        this.service.getProjectGalleryImage(payload).then(
            (result: any) => {
                this.fileSrc = result.imageData;
            }
        );
    }

    openFolder(folder: any, node: any, ev: any): void {
        if (this.selectedFolder != null) this.selectedFolder.selected = false;
        console.log('doing the folder thingie: ', folder);    
        console.log('node: ', node);
        console.log('event: ', ev);
        this.selectedFolder = folder;
        this.selectedFolder = { ...folder, eventData: ev, selected: true };
        this.galleryData = [];
        this.resetImageQueueList();
        if (this.selectedFolder.isDirectory === true) {
            let children = this.selectedFolder.items;
            if (node != null && node.children != null) children = node.children;

            if (children == null) return;
            children.forEach((item: any) => {
                let focusData = item;
                if (item.data != null) focusData = item.data;
                if (focusData.isValidFile == true && focusData.isDirectory == false) {
                    this.galleryData.push({
                        ProjectId: this.projectId,
                        FilePath: focusData.serverRelativeUrl,
                        FileName: focusData.name,
                        imageLoaded: false
                    });
                }
            });

            this.initImageGrid();
            this.renderCount++;
        }
    }

    initNewFolder(e: any, data: any): void {
        this.newFolderData = { ParentFolder: data.serverRelativeUrl, NewFolderName: '' };
        this.newFolderFormVisible = true;
    }

    onNodesInitialized(e: any) {
        e.component.selectRows([1], false); // false = do not preserve previous selection
        this.openFolder(this.galleryFolderData[0], null, e);
    }
}